// ** Third Party Components
import styled, { css } from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledBluredAvatarContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	height: 100%;
	width: 100%;
	overflow: hidden;
	${({ hasDefaultAvatar }) =>
		hasDefaultAvatar &&
		css`
			background-color: #8a8a8a;
		`}
	border-top-left-radius: ${({ theme: { borderRadius } }) =>
		borderRadius.card};
	border-top-right-radius: ${({ theme: { borderRadius } }) =>
		borderRadius.card};

	@media (max-width: ${breakpoints.phone - 1}px) {
		border-radius: 0;
	}
`;
